export const UserRoles = {
	SystemAdmin: "1",
	HousekeeperCreator: "2",
	CustomerAdmin: "3",
	Learner: "4",
};

export const UserRoleIds = {
	SystemAdmin: "1",
	Housekeeper: "2",
	ContentCreator: "3",
	CustomerAdmin: "4",
	Demonstrator: "5",
	Learner: "6",
	ContentPublisher: "7"
};
